import React from 'react'

type Point = { x: number; y: number }

export default function Sparkline({ values, width = 240, height = 60, color = '#4f46e5' }: { values: number[]; width?: number; height?: number; color?: string }) {
  if (!values.length) return <div className="h-[60px]" />
  const max = Math.max(...values)
  const min = Math.min(...values)
  const span = Math.max(1, max - min)
  const stepX = width / Math.max(1, values.length - 1)
  const pts: Point[] = values.map((v, i) => ({ x: i * stepX, y: height - ((v - min) / span) * height }))
  const d = pts.map((p, i) => (i === 0 ? `M ${p.x} ${p.y}` : `L ${p.x} ${p.y}`)).join(' ')
  const area = `M 0 ${height} ` + pts.map((p) => `L ${p.x} ${p.y}`).join(' ') + ` L ${width} ${height} Z`
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="overflow-visible">
      <path d={area} fill={color + '22'} />
      <path d={d} fill="none" stroke={color} strokeWidth={2} />
    </svg>
  )
}
